module.exports = __webpack_public_path__ + "static/media/r4s4.238fd36b.jpg";